import { Table, Space, Switch,   Popover } from "antd";
import Main from "../components/layout/Main";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  UserAddOutlined,
  UserOutlined,
  ReconciliationOutlined,
  ArrowLeftOutlined,
  EditOutlined,
  DeleteOutlined,
  FolderOpenOutlined,
    InfoCircleOutlined,
} from "@ant-design/icons";
import Header from "../components/layout/Header";
import { Modal } from "antd";
import { useState, useEffect } from "react";
import { get, put, remove, post } from "../Libraries/Ajax/HttpService";
import back from "../assets/images/back.svg";
import deleteIcon from "../assets/images/delete.svg";
import edit from "../assets/images/edit.svg";
import { useDistrict } from "../utils/DistrictContext";
import { toast } from "react-toastify";
function Listuser() {
  var mcdata = JSON.parse(localStorage.getItem("MCData"));
  const [loading, setloading] = useState(true);
  const [open, setOpen] = useState(false);
  const [opens, setOpens] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState("");
  const [modalValue, setModalValue] = useState("");
  const [modalUnit, setModalUnit] = useState("");
  const [modalStatus, setModalStatus] = useState("");
  const [modalDisplay, setModalDisplay] = useState("");
  const [modalId, setModalId] = useState("");
  const [datas, setDatas] = useState([]);
  const { selectedDistrict } = useDistrict();
  const navigate = useNavigate();
  // const [selectedYear, setSelectedYear] = useState("");
  // const [selectedMonth, setSelectedMonth] = useState("");
  const now = new Date();
  const prevMonth = now.getMonth() === 0 ? 12 : now.getMonth(); // if Jan, then Dec (12)
  const prevYear =
    now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear();

  const [selectedYear, setSelectedYear] = useState(prevYear);
  const [selectedMonth, setSelectedMonth] = useState(prevMonth);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadComplete, setUploadComplete] = useState(false);
  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!selectedYear || !selectedMonth) {
      toast.info("Please select both year and month before uploading!");
      e.target.value = ""; // reset file input
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("year", selectedYear);
    formData.append("month", selectedMonth);

    setUploading(true);
    setUploadProgress(0);
    setUploadComplete(false);

    try {
      const response = await post("apis/upload_flow", formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(percentCompleted);
        },
      });

      console.log("Upload success:", response);
      setUploadComplete(true);
      toast.success("File Uploaded successfully");
    } catch (error) {
      console.error("Upload failed:", error);
      if (error.response?.data?.error) {
        toast.error(error.response.data.error);
      } else {
        toast.error("File upload failed. Please try again.");
      }
    } finally {
      setUploading(false);
    }
  };
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    // {
    //   title: 'Type',
    //   dataIndex: 'type',
    //   key: 'type'
    // },
    // {
    //   title: 'Frequency',
    //   dataIndex: 'frequency',
    //   key: 'frequency'
    // },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
    },
    {
      title: "Unit",
      dataIndex: "unit",
      key: "unit",
    },
    {
      title: "Display Name",
      dataIndex: "display_name",
      key: "display_name",
    },
    {
      title: "Status",
      dataIndex: "active",
      key: "active",
      render: (_, record) => (record.active === true ? "Active" : "Inactive"),
    },

    {
      title: "Edit",
      dataIndex: "action",
      align: "center",
      key: "id",
      onCell: (record) => {
        return {
          onClick: (ev) => {
            onEditClick(
              record.id,
              record.name,
              record.value,
              record.unit,
              record.active,
              record.display_name
            );
          },
        };
      },
      render: (_, record) => (
        <Space>
          <img
            src={edit}
            alt="Edit"
            style={{ width: "25px", verticalAlign: "middle" }}
          />
        </Space>
      ),
    },
    {
      title: "Delete",
      dataIndex: "actions",
      align: "center",
      key: "id",
      onCell: (record) => {
        return {
          onClick: (ev) => {
            modaldel(record.id);
          },
        };
      },
      render: (_, record) => (
        <Space>
          <img
            src={deleteIcon}
            alt="delete"
            style={{ width: "25px", verticalAlign: "middle" }}
          />
        </Space>
      ),
    },
  ];

  const showModal = () => {
    setOpen(true);
  };
  const handleOks = () => {
    const url = `apis/admin_settings/${modalId}`;
    remove(url).then((res) => {
      console.log(res);
      setConfirmLoading(true);
      setTimeout(() => {
        setOpen(false);
        setConfirmLoading(false);
      }, 2000);
    });

    window.location.reload();
  };
  const handleOk = () => {
    const params = JSON.stringify({
      field_name: modalText,
      active: modalStatus,
      value: modalValue,
      unit: modalUnit,
      display_name: modalDisplay,
    });
    const url = `apis/admin_settings_edit/${modalId}`;

    put(url, params).then((res) => {
      console.log(res);
      setOpen(false);
      window.location.reload();
    });
  };
  const handleCancel = () => {
    console.log("Clicked cancel button");
    setOpen(false);
  };
  const handleCancels = () => {
    console.log("Clicked cancel button");
    setOpens(false);
  };
  const onEditClick = (id, name, value, unit, active, display_name) => {
    console.log(id);
    setOpen(true);
    setModalId(id);
    setModalText(name);
    setModalValue(value);
    setModalUnit(unit);
    setModalDisplay(display_name);
    setModalStatus(active);
  };

  useEffect(() => {
    getData();
    console.log("selecteddis", selectedDistrict);
  }, [selectedDistrict]);

  const getData = async () => {
    get("apis/admin_settings/all_list").then((res) => {
      setloading(true);
      setDatas(
        res.data.data.map((row) => ({
          name: row.field_name,
          value: row.value,
          unit: row.unit,
          active: row.active,
          id: row.id,
          display_name: row.display_name,
        }))
      );

      console.log(res?.data?.data?.length);
    });
    setloading(false);
  };

  const { Column, ColumnGroup } = Table;
  const modalclick = () => {
    setOpen(true);
  };
  const modaldel = (id) => {
    setOpens(true);
    setModalId(id);
  };
  const onMouseClickpath = (event) => {
    navigate("/settings");
  };
  const onActiveChange = (checked) => {
    setModalStatus(checked);
  };
  const onselectClick = () => {
    navigate("/settingsuser");
  };
  const onselectMetermangement = () => {
    navigate("/metermanagement");
  };

  const onselectMeterHistory = () => {
    navigate("/meterhistory");
  };

  const onselectClicks = () => {
    navigate("/list");
  };
  const onselectClickaccount = () => {
    navigate("/accountnames");
  };
  const onselectClickss = () => {
    navigate(-1);
  };

  const onFinish = (values) => {
    console.log(values);
  };
  return (
    <>
      <Header />
      <Main>
        <div>
          <div className="d-flex align-items-center justify-content-between flex-wrap mb-0">
            <div className="d-flex ">
              <img
                src={back}
                alt=""
                style={{ width: "10px", cursor: "pointer" }}
                onClick={onselectClickss}
              />

              <div className="d-flex align-items-center">
                {mcdata.mcdatas.type === "U" && mcdata.mcdatas.type === "U" ? (
                  ""
                ) : (
                  <>
                    <div
                      className="new-box-padding  text-blue  align-self-center c-pointer"
                      style={{
                        borderBottom: "2px solid #1998f0",
                        borderRadius: "0",
                      }}
                      onClick={onselectClick}
                    >
                      {" "}
                      Settings
                    </div>
                    <div
                      className=""
                      style={{
                        width: "2px",
                        height: "25px",
                        background: "#ccc",
                      }}
                    ></div>
                  </>
                )}

                {mcdata.mcdatas.type === "U" && mcdata.mcdatas.type === "U" ? (
                  ""
                ) : (
                  <>
                    <div
                      className="new-box-padding   align-self-center c-pointer "
                      onClick={onselectClicks}
                      style={{
                        borderBottom: "2px solid #ccc",
                      }}
                    >
                      {" "}
                      Users
                    </div>
                  </>
                )}
                <div
                  className=""
                  style={{ width: "2px", height: "25px", background: "#ccc" }}
                ></div>
                <div
                  className="new-box-padding   align-self-center c-pointer "
                  onClick={onselectClickaccount}
                  style={{
                    borderBottom: "2px solid #ccc",
                  }}
                >
                  {" "}
                  Accounts
                </div>
                {/* {mcdata.mcdatas.type === "U" && mcdata.mcdatas.type === "U" ? (
                  ""
                ) : (
                  <>
                    <div
                      className=""
                      style={{
                        width: "2px",
                        height: "25px",
                        background: "#ccc",
                      }}
                    ></div>
                    <div
                      className="new-box-padding   align-self-center c-pointer "
                      onClick={onselectMetermangement}
                      style={{
                        borderBottom: "2px solid #ccc",
                      }}
                    >
                      {" "}
                      Meter Management
                    </div>
                  </>
                )}

                {mcdata.mcdatas.type === "U" && mcdata.mcdatas.type === "U" ? (
                  ""
                ) : (
                  <>
                    <div
                      className=""
                      style={{
                        width: "2px",
                        height: "25px",
                        background: "#ccc",
                      }}
                    ></div>
                    <div
                      className="new-box-padding   align-self-center c-pointer "
                      onClick={onselectMeterHistory}
                      style={{
                        borderBottom: "2px solid #ccc",
                      }}
                    >
                      {" "}
                      Meter History
                    </div>
                  </>
                )} */}
                {mcdata.mcdatas.type === "U" || selectedDistrict === "FB151" ? (
                  ""
                ) : (
                  <>
                    {/* <div
                      style={{
                        width: "2px",
                        height: "25px",
                        background: "#ccc",
                      }}
                    ></div>
                    <div
                      className="new-box-padding align-self-center c-pointer"
                      onClick={onselectMetermangement}
                      style={{ borderBottom: "2px solid #ccc" }}
                    >
                      Meter Management
                    </div> */}
                  </>
                )}

                {mcdata.mcdatas.type === "U" || selectedDistrict === "FB151" ? (
                  ""
                ) : (
                  <>
                    {/* <div
                      style={{
                        width: "2px",
                        height: "25px",
                        background: "#ccc",
                      }}
                    ></div>
                    <div
                      className="new-box-padding align-self-center c-pointer"
                      onClick={onselectMeterHistory}
                      style={{ borderBottom: "2px solid #ccc" }}
                    >
                      Meter History
                    </div> */}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        {selectedDistrict == "FB151" ? (
          <>
            <div className="bg-white border rounded p-4 mt-4">
              <div className="d-flex justify-content-start align-items-center gap-2 mb-4">
              <h4 className="text-blue fw-bold">Monthly Source Data</h4>
              <Space className="me-3 mb-2">
                                <Popover
                                  trigger="click"
                                  content={
                                    <div
                                      style={{
                                        width: "250px",
                                        textAlign: "left",
                                      }}
                                    >
                                    Upload source data by selecting the required year and month, then click Upload
                                    </div>
                                  }
                                  placement="top"
                                  getPopupContainer={(trigger) =>
                                    trigger.parentElement
                                  }
                                >
                                  <InfoCircleOutlined
                                    onClick={(e) => e.stopPropagation()} 
                                    style={{
                                      color: "#1890ff",
                                      cursor: "pointer",
                                      marginTop: "8px",
                                    }}
                                  />
                                </Popover>
                              </Space>
</div>
              <div className="d-flex align-items-center justify-content-between flex-wrap">
                <div className="d-flex gap-3 align-items-center">
                  {/* Year Selector */}
                  <select
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                    className="form-select"
                    style={{ width: "120px" }}
                  >
                    <option value="">Year</option>
                    {Array.from({ length: 10 }, (_, i) => {
                      const year = new Date().getFullYear() - i;
                      return (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      );
                    })}
                  </select>

                  {/* Month Selector */}
                  <select
                    value={selectedMonth}
                    onChange={(e) => setSelectedMonth(e.target.value)}
                    className="form-select"
                    style={{ width: "120px" }}
                  >
                    <option value="">Month</option>
                    {[
                      "January",
                      "February",
                      "March",
                      "April",
                      "May",
                      "June",
                      "July",
                      "August",
                      "September",
                      "October",
                      "November",
                      "December",
                    ].map((month, index) => (
                      <option key={month} value={index + 1}>
                        {month}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <input
                    type="file"
                    accept=".xlsx"
                    id="xlsxUpload"
                    style={{ display: "none" }}
                    onChange={handleFileUpload}
                  />
                  <button
                    className="btn btn-primary"
                    onClick={() =>
                      document.getElementById("xlsxUpload").click()
                    }
                    style={{
                      backgroundColor: "#1998f0",
                      border: "none",
                      borderRadius: "6px",
                      padding: "8px 16px",
                      fontSize: "16px",
                      cursor: "pointer",
                    }}
                  >
                    Upload XLSX
                  </button>
                </div>
              </div>

              {/* Upload Progress */}
              {uploading && (
                <div style={{ marginTop: "20px" }}>
                  <div style={{ marginBottom: "5px" }}>
                    Uploading... {uploadProgress}%
                  </div>
                  <div
                    style={{
                      height: "10px",
                      background: "#eee",
                      borderRadius: "4px",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        width: `${uploadProgress}%`,
                        height: "100%",
                        background: "#1998f0",
                        transition: "width 0.2s ease",
                      }}
                    ></div>
                  </div>
                </div>
              )}

              {uploadComplete && (
                <div style={{ color: "#1998f0", marginTop: "10px" }}>
                  ✅ Upload completed successfully!
                </div>
              )}
            </div>
          </>
        ) : (
          ""
        )}

        <div className="d-flex align-items-center justify-content-between px-2 mt-4 mb-4">
          <h4 className="text-blue fw-bold mb-0">Default Parameters</h4>

          <div
            className="new-box-padding bg-white border rounded d-flex text-blue align-items-center c-pointer"
            onClick={onMouseClickpath}
            style={{
              width: "180px",
              justifyContent: "center",
              fontSize: "18px",
              cursor: "pointer",
            }}
          >
            Add New
          </div>
        </div>

        {datas.length > 0 ? (
          <Table
            columns={columns}
            dataSource={datas}
            className="settingsTable mt-4"
            pagination={false}
          />
        ) : (
          <div className="no-found">
            <div>
              <FolderOpenOutlined />
              <span className="found-text">No data Found</span>
            </div>
          </div>
        )}

        {open === true ? (
          <Modal
            open={open}
            onOk={handleOk}
            confirmLoading={confirmLoading}
            onCancel={handleCancel}
            centered="true"
            okText="Update"
          >
            <form class="form-horizontal bg-white mx-auto p-3 login-form">
              <div class="forms-inputs mt-3">
                <span for="pwd">Name</span>
                <input
                  type="text"
                  class="form-control"
                  id="pwd"
                  placeholder="Enter Name"
                  defaultValue={modalText}
                  readOnly={true}
                  onChange={(e) => {
                    setModalText(e.target.value);
                  }}
                />
              </div>

              <div class="forms-inputs">
                <span for="value">Value</span>
                <input
                  type="text"
                  class="form-control"
                  id="value"
                  placeholder="Enter Value"
                  defaultValue={modalValue}
                  onChange={(e) => {
                    setModalValue(e.target.value);
                  }}
                />
              </div>
              <div class="forms-inputs">
                <span for="unit">Unit</span>
                <input
                  type="text"
                  class="form-control"
                  id="unit"
                  placeholder="Enter Unit"
                  defaultValue={modalUnit}
                  onChange={(e) => {
                    setModalUnit(e.target.value);
                  }}
                />
              </div>
              <div class="forms-inputs">
                <span for="value">Display</span>
                <input
                  type="text"
                  class="form-control"
                  id="display_name"
                  placeholder="Enter Value"
                  defaultValue={modalDisplay}
                  onChange={(e) => {
                    setModalDisplay(e.target.value);
                  }}
                />
              </div>
              <div class="checkbox">
                <span>
                  <b>Status</b>
                </span>
                <br />
                <Switch
                  defaultChecked={modalStatus}
                  onChange={onActiveChange}
                />
              </div>
            </form>
          </Modal>
        ) : (
          ""
        )}
        {opens === true ? (
          <Modal
            open={opens}
            onOk={handleOks}
            confirmLoading={confirmLoading}
            onCancel={handleCancels}
            centered="true"
          >
            <h5 className="text-left pt-4">
              Are you sure you want to permanently remove this item?
            </h5>
          </Modal>
        ) : (
          ""
        )}
      </Main>
    </>
  );
}
export default Listuser;
